import { useCallback, useState } from 'react';

import { noop } from 'lodash';

import { IUseAccordionItemProps } from './types';

export const useAccordionItem = ({ onInteract = noop }: IUseAccordionItemProps = {}) => {
  const [isActive, setIsActive] = useState(false);
  const [isFirstInteraction, setIsFirstInteraction] = useState(true);

  const handleToggle = useCallback(
    (activeState?: boolean) => {
      const newState = activeState ?? !isActive;
      setIsActive(newState);
      onInteract(newState, isFirstInteraction);
      setIsFirstInteraction(false);
    },
    [isActive, isFirstInteraction, onInteract]
  );

  return {
    handleToggle,
    isActive,
  };
};
